import styled from "styled-components";

export const DateStyle = styled.p`
  margin-top: 0px;
  font-size: small;
`;
